import styled from 'styled-components';

const CardsContainerStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -0.8rem -0.8rem;
`;

export default CardsContainerStyled;
